import * as React from "react";
import styled from "../../../styled/index";
const autobind = require("class-autobind").default;
import { ChromePicker } from "react-color";
import { CoreUtils } from "@lib/common";
const ClickOutComponent = require("react-onclickout");
const Wrapper = styled("div") `
  display: inline-block;
  position: relative;
`;
const SwatchWrapper = styled("div") `
  display: inline-block;
  cursor: pointer;
  background: white;
  box-shadow: 0 0 0 1px rgba(0,0,0,.1);
  padding: 3px;
  border-radius: 3px;
`;
const Swatch = styled("div") `
  width: 36px;
  height: 18px;
  border-radius: 3px;
  background: ${({ color }) => color};
`;
const DropWrapper = styled("div") `
  position: absolute;
  top: 125%;
  left: 0;
  display: ${({ active }) => active ? "block" : "none"};
  z-index: 3;
`;
export class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.lastOpened = null;
        autobind(this);
        this.state = { active: false };
        this.lastOpened = null;
    }
    componentDidUpdate() {
        this.lastOpened = this.state.active ? Date.now() : null;
    }
    setActive(active) {
        this.setState({ active });
    }
    onClickOut() {
        if (this.state.active && this.lastOpened && ((Date.now() - this.lastOpened) > 100)) {
            this.setActive(false);
        }
    }
    render() {
        const { active } = this.state;
        const { color, onChange } = this.props;
        const finalColor = color && color.length > 7 ?
            CoreUtils.colors.rgbaObjectFromString(color) : color;
        return (React.createElement(Wrapper, null,
            React.createElement(SwatchWrapper, { onClick: () => this.setActive(!this.state.active) },
                React.createElement(Swatch, { color: color })),
            React.createElement(ClickOutComponent, { onClickOut: this.onClickOut },
                React.createElement(DropWrapper, { active: active },
                    React.createElement(ChromePicker, { color: finalColor, onChangeComplete: (Color) => onChange(CoreUtils.colors.stringFromRgba(Color.rgb)) })))));
    }
}
//# sourceMappingURL=index.js.map